import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import { Modal, Skeleton, Empty } from 'core/components/ui'
import TitleItem from 'core/layouts/title-item'

const ModalEquipments = props => {
  const { intl, id, handleClickClose } = props

  const { loading, getEquipments, equipments } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const [modalVisible, setModalVisible] = useState(false)

  const closeModal = () => {
    setModalVisible(false)
    handleClickClose()
  }

  useEffect(() => {
    const runIt = item => {
      const params = { id: item }
      setModalVisible(true)
      getEquipments(params)
    }
    if (id) runIt(id)
  }, [id])

  return (
    <Modal
      title={intl.formatMessage({
        id: 'configurator-finishes-modal-tiltle'
      })}
      visible={modalVisible}
      okButtonProps={null}
      cancelButtonProps={null}
      onOk={closeModal}
      onCancel={closeModal}
      footer={null}
    >
      <Skeleton loading={loading} active>
        {equipments ? (
          equipments.equipments.map(el => (
            <React.Fragment key={el.id}>
              <TitleItem>{el.equipment}</TitleItem>
            </React.Fragment>
          ))
        ) : (
          <Empty />
        )}
      </Skeleton>
    </Modal>
  )
}
ModalEquipments.defaultProps = {
  id: null,
  handleClickClose: null
}

ModalEquipments.propTypes = {
  handleClickClose: PropTypes.func,
  intl: PropTypes.shape().isRequired,
  id: PropTypes.string
}

export default injectIntl(ModalEquipments)
